import "./Appointment.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AppointmentBookingForm from "./sections/AppointmentBookingForm";
import Footer from "@/reusable_sections/Footer";
export default function AppointmentPage() {
  return <div>
      <Header />
      <Hero />
      <AppointmentBookingForm />
      <Footer />
    </div>;
}